import s from './summary.module.scss';
import { useLocation } from 'react-router-dom';
import {
	BundleStr,
	CategoryStr,
	QuestionStr,
	Q_STATUS,
	ReactPressVars,
} from '../../types';
import { useMedia } from 'react-use';
import Button from '../../components/common/Button/Button';
import { ReactComponent as SvgView } from '../../aassets/ic/ic_search_doc.svg';
import { ReactComponent as SvgOk } from '../../aassets/ic/ui/ic_ok.svg';
import { ReactComponent as SvgSad } from '../../aassets/ic/ui/is_sad.svg';
import Modal from 'react-modal';
import { MouseEvent, useRef, useState } from 'react';

import SingleQuestion from '../../components/quiz/SingleQuestion/SingleQuestion';
import BundleContent from '../../components/quiz/BundleContent/BundleContent';
import '../../styles/pageModules/quiz.scss';
interface Props {
	root: HTMLElement;
	wpdata: ReactPressVars;
}
const Summary = ({ root, wpdata }: Props) => {
	const locState = useLocation().state;

	const questions = locState?.questions as QuestionStr[];
	const bundles = locState?.bundles as BundleStr[];
	const categories = locState?.categories as (CategoryStr & {
		time: number;
	})[];
	const isWide = useMedia('(min-width: 1200px)');
	const rows =
		questions && isWide ? (
			<div className={s.qsw}>
				<div className={`${s.qw} ${s.qws_titles}`}>
					<div className={s.qw_makat}>ID</div>
					<div className={s.qw_status}>מענה</div>
					<div className={s.qw_time}>זמן פיתרון</div>
					<div className={s.qw_cat}>קטגוריה</div>
					<div className={s.qw_lvl}>קושי</div>
					<div className={s.qw_view}></div>
				</div>
				{questions.map((q, i) => {
					return (
						<div className={s.qw} key={`qw${i}`}>
							<div className={s.qw_makat}>{q.id}</div>
							<div className={s.qw_status}>
								{q?.status === Q_STATUS.RIGHT ? (
									<div className={s.qw_status_ok}>
										<SvgOk />
										<span>ענית נכון</span>
									</div>
								) : q.status === Q_STATUS.TIMED ? (
									<div className={s.qw_status_err}>
										<SvgSad />
										<span>אזל הזמן</span>
									</div>
								) : (
									<div className={s.qw_status_err}>
										<SvgSad />
										<span>טעית</span>
									</div>
								)}
							</div>
							<div className={s.qw_time}>
								{q.exersizeTime ?? ''}
							</div>
							<div className={s.qw_cat}>
								{categories.find((c) => c.id === q.category_id)
									?.name ?? '...'}
							</div>
							<div className={s.qw_lvl}>
								{q.is_700 ? q.level_700 : q.level}
							</div>

							<div className={s.qw_view}>
								<Button
									width="inline"
									size="small"
									customClass={s.btn_view}
									isWithIcon
									onClick={(e) => handleViewClick(e, i)}>
									צפה
									<SvgView />
								</Button>
							</div>
						</div>
					);
				})}
			</div>
		) : (
			questions && (
				<div className={s.qs}>
					{questions.map((q, i) => {
						return (
							<div className={s.q} key={`q${i}`}>
								<div className={s.mrow}>
									<div
										className={`${s.mrow_in} ${s.mrow_title}`}>
										ID
									</div>
									<div
										className={`${s.mrow_in} ${s.mrow_title}`}>
										קטגוריה
									</div>
								</div>
								<div className={s.mrow}>
									<div className={s.mrow_in}>{q.id}</div>
									<div className={s.mrow_in}>
										{
											categories.find(
												(c) => c.id === q.category_id
											)?.name
										}
									</div>
								</div>

								<div className={s.mrow}>
									<div
										className={`${s.mrow_in} ${s.mrow_title}`}>
										מענה
									</div>
									<div
										className={`${s.mrow_in} ${s.mrow_title}`}>
										זמן פיתרון
									</div>
								</div>
								<div className={s.mrow}>
									<div
										className={`${s.mrow_in} ${s.q_status}`}>
										{q?.status === Q_STATUS.RIGHT ? (
											<div className={s.q_status_ok}>
												<SvgOk />
												<span>ענית נכון</span>
											</div>
										) : q.status === Q_STATUS.TIMED ? (
											<div className={s.q_status_err}>
												<SvgSad />
												<span>אזל הזמן</span>
											</div>
										) : (
											<div className={s.q_status_err}>
												<SvgSad />
												<span>טעית</span>
											</div>
										)}
									</div>
									<div className={s.mrow_in}>
										{q.exersizeTime}
									</div>
								</div>

								<div className={s.mrow}>
									<div
										className={`${s.mrow_in} ${s.mrow_title}`}>
										רמת קושי
									</div>
									<div
										className={`${s.mrow_in} ${s.mrow_title}`}></div>
								</div>
								<div className={s.mrow}>
									<div className={s.mrow_in}>
										{q.is_700 ? q.level_700 : q.level}
									</div>
									<div className={s.mrow_in}></div>
								</div>

								<div className={s.q_view}>
									<Button
										width="full"
										customClass={s.btn_mview}
										isWithIcon
										onClick={(e) => handleViewClick(e, i)}>
										צפה
										<SvgView />
									</Button>
								</div>
							</div>
						);
					})}
				</div>
			)
		);

	const time = useRef<string | undefined>();

	const [modalIsOpen, setModalIsOpen] = useState(false);
	const [modalContent, setModalContent] = useState<{
		bundleConent?: string;
		question: QuestionStr;
	}>();

	const handleViewClick = (e: MouseEvent, index: number): void => {
		e.preventDefault();
		e.stopPropagation();

		const q = questions[index];
		time.current = q.exersizeTime;

		setModalContent({
			bundleConent: q.bundle_id
				? bundles.find((b) => b.id === q.bundle_id)?.content ??
				  undefined
				: undefined,
			question: q,
		});
		setModalIsOpen(true);
	};

	return (
		<>
			<section className={s.rt}>
				<div className={`${s.cnt} ${s.cnt_top}`}>
					<h1 className="app_h1">סיכום התרגול</h1>
				</div>
				<div className={`${s.cnt} ${s.cnt_content}`}>{rows}</div>
			</section>
			<Modal
				isOpen={modalIsOpen}
				onRequestClose={() => setModalIsOpen(false)}
				contentLabel="תמונה"
				closeTimeoutMS={300}
				className={{
					base: s['m__content'],
					afterOpen: s['m__content--after-open'],
					beforeClose: s['m__content--before-close'],
				}}
				overlayClassName={{
					base: s['m__overlay'],
					afterOpen: s['m__overlay--after-open'],
					beforeClose: s['m__overlay--before-close'],
				}}
				appElement={root}>
				<div className={s.timer}>
					<div className={s.timer_inn}>{time.current}</div>
				</div>
				{modalContent?.bundleConent && (
					<div className={s.b_ctn_wrp}>
						<BundleContent
							content={modalContent.bundleConent}
							show={false}
						/>
					</div>
				)}
				{modalContent?.question && (
					<SingleQuestion
						q={modalContent.question}
						isTimed={false}
						showSolution={true}
						onAnswerSelectCallback={(isRight: boolean) => {}}
						isQuiz={false}
					/>
				)}

				<button
					className={s.m__btn}
					onClick={() => setModalIsOpen(false)}>
					X
				</button>
			</Modal>
		</>
	);
};
export default Summary;
